/**
 * Monthlees member price modal — full-screen Welcome Kit-style bundle without gifts.
 */
(function () {
  'use strict';

  var MODAL = '[data-monthlees-member-price-modal]';
  var OPEN_TRIGGER = '[data-mmp-open]';
  var TRIGGER_WRAP = '[data-mmp-trigger-wrap]';
  var BODY_LOCK_CLASS = 'monthlees-member-price-modal-open';

  function readConfig(modal) {
    var node =
      (modal && modal.querySelector('[data-mmp-config]')) ||
      document.querySelector('[data-mmp-config]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return {};
    }
  }

  function isMemberPricingActive() {
    if (document.body && document.body.getAttribute('data-monthlees-persistent-member') === 'true') {
      return true;
    }
    if (document.body && document.body.getAttribute('data-monthlees-membership-in-cart') === 'true') {
      return true;
    }
    return !!document.querySelector('.monthlees-membership-message--active');
  }

  function getBundle() {
    return window.MonthleesMembershipBundle || null;
  }

  function formatMoney(cents, moneyFormat) {
    var bundle = getBundle();
    if (bundle && typeof bundle.formatMoney === 'function') {
      return bundle.formatMoney(cents, moneyFormat);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function syncTriggerVisibility() {
    if (!isMemberPricingActive()) return;

    document.querySelectorAll(TRIGGER_WRAP).forEach(function (wrap) {
      wrap.setAttribute('hidden', '');
    });
  }

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  function initModal(modal) {
    if (!modal || modal.dataset.initialized === 'true') return;

    var config = readConfig(modal);
    var dialog = modal;
    var closeEls = modal.querySelectorAll('[data-mmp-close]');
    var addButtons = modal.querySelectorAll('[data-mmp-add-to-cart]');
    var statusEl = modal.querySelector('[data-mmp-status]');
    var planInputs = modal.querySelectorAll('[data-mmp-plan-input]');
    var productTitleEl = modal.querySelector('[data-mmp-product-title]');
    var productPriceEl = modal.querySelector('[data-mmp-product-price]');
    var productCompareEl = modal.querySelector('[data-mmp-product-compare]');
    var productImageEl = modal.querySelector('[data-mmp-product-image]');
    var productImagePlaceholder = modal.querySelector('[data-mmp-product-image-placeholder]');

    var lastTrigger = null;
    var productContext = null;
    var state = { plan: 'annual' };
    var boldRetryTimer = null;

    function getSelectedPlan() {
      var selected = modal.querySelector('[data-mmp-plan-input]:checked');
      return selected ? selected.value : 'annual';
    }

    function membershipCents() {
      return state.plan === 'annual' ? config.membershipAnnualCents : config.membershipMonthlyCents;
    }

    function resolveBoldProductPrice(trigger) {
      var bold = window.MonthleesBoldPricing;
      if (!bold || !trigger || !productContext) {
        return { boldApplied: false, text: null, cents: 0 };
      }

      var domResolved = bold.resolveFromTrigger(trigger);
      if (domResolved.boldApplied) {
        return domResolved;
      }

      return bold.resolveMemberPreview(productContext.variantId, productContext.guestCents, {
        subscription: productContext.requireProductSubscription,
        moneyFormat: config.moneyFormat,
      });
    }

    function updateBreakdown() {
      state.plan = getSelectedPlan();

      if (productTitleEl && productContext) {
        productTitleEl.textContent = productContext.title || '';
      }

      var applyPrice = function (resolved) {
        if (productPriceEl) {
          if (resolved && resolved.boldApplied && resolved.text) {
            productPriceEl.textContent = resolved.text;
          } else if (resolved && resolved.boldApplied && resolved.cents) {
            var display = formatMoney(resolved.cents, config.moneyFormat);
            if (productContext.requireProductSubscription) {
              display += '/mo';
            }
            productPriceEl.textContent = display;
          } else {
            productPriceEl.textContent = '—';
          }
        }
      };

      var resolved = lastTrigger ? resolveBoldProductPrice(lastTrigger) : null;
      applyPrice(resolved);

      if (productCompareEl) {
        if (productContext && productContext.traditionalCents) {
          productCompareEl.textContent = formatMoney(productContext.traditionalCents, config.moneyFormat);
          productCompareEl.removeAttribute('hidden');
        } else {
          productCompareEl.setAttribute('hidden', '');
        }
      }
    }

    function scheduleBoldPriceRetries() {
      if (boldRetryTimer) {
        window.clearTimeout(boldRetryTimer);
        boldRetryTimer = null;
      }

      var bold = window.MonthleesBoldPricing;
      var load = bold && bold.loadMemberIndex ? bold.loadMemberIndex() : Promise.resolve();

      load.then(function () {
        [0, 200, 500, 1000].forEach(function (ms) {
          window.setTimeout(function () {
            if (!lastTrigger || modal.hasAttribute('hidden')) return;
            updateBreakdown();
          }, ms);
        });
      });
    }

    function populateProductMedia() {
      if (!productContext) return;

      if (productImageEl) {
        if (productContext.imageUrl) {
          productImageEl.src = productContext.imageUrl;
          productImageEl.alt = productContext.title || '';
          productImageEl.removeAttribute('hidden');
          if (productImagePlaceholder) productImagePlaceholder.setAttribute('hidden', '');
        } else {
          productImageEl.setAttribute('hidden', '');
          if (productImagePlaceholder) productImagePlaceholder.removeAttribute('hidden');
        }
      }
    }

    function readTriggerContext(trigger) {
      return {
        productId: trigger.getAttribute('data-product-id'),
        variantId: trigger.getAttribute('data-variant-id'),
        title: trigger.getAttribute('data-product-title') || '',
        handle: trigger.getAttribute('data-product-handle') || '',
        url: trigger.getAttribute('data-product-url') || '',
        imageUrl: trigger.getAttribute('data-product-image') || '',
        guestCents: parseInt(trigger.getAttribute('data-guest-cents'), 10) || 0,
        traditionalCents: parseInt(trigger.getAttribute('data-traditional-cents'), 10) || 0,
        sellingPlanId: trigger.getAttribute('data-product-selling-plan-id') || null,
        requireProductSubscription: trigger.getAttribute('data-require-product-subscription') === 'true',
      };
    }

    function openModal(trigger) {
      if (isMemberPricingActive()) return;

      productContext = readTriggerContext(trigger);
      lastTrigger = trigger;

      var annualInput = modal.querySelector('[data-mmp-plan-input][value="annual"]');
      if (annualInput) annualInput.checked = true;
      state.plan = 'annual';

      populateProductMedia();
      updateBreakdown();
      scheduleBoldPriceRetries();

      if (statusEl) {
        statusEl.textContent = '';
        statusEl.classList.add('visually-hidden');
      }

      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add(BODY_LOCK_CLASS);

      var focusTarget = modal.querySelector('[data-mmp-close]');
      if (focusTarget) focusTarget.focus();
    }

    function closeModal() {
      modal.setAttribute('hidden', '');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove(BODY_LOCK_CLASS);

      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus();
      }
      lastTrigger = null;
      productContext = null;
    }

    function setStatus(message, isError) {
      if (!statusEl) return;
      statusEl.textContent = message || '';
      statusEl.classList.toggle('visually-hidden', !message);
      statusEl.style.color = isError ? '#b91c1c' : '';
    }

    function setAddButtonsDisabled(disabled) {
      addButtons.forEach(function (btn) {
        btn.disabled = disabled;
      });
    }

    function handleAddToCart() {
      var bundle = getBundle();
      if (!bundle || !productContext) return;

      var plan = getSelectedPlan();
      state.plan = plan;
      setStatus(config.loadingLabel || 'Adding to cart…', false);
      setAddButtonsDisabled(true);

      bundle
        .fetchCart()
        .then(function (cart) {
          var skipMembership = bundle.membershipInCart(cart, config);
          var built = bundle.buildCartItems(
            Object.assign({}, config, { skipMembershipAdd: skipMembership }),
            {
              variantId: productContext.variantId,
              sellingPlanId: productContext.sellingPlanId,
              requireProductSubscription: productContext.requireProductSubscription,
            },
            plan
          );

          if (built.errors.length) {
            throw new Error(built.errors[0]);
          }

          return bundle.addCartItemsSequential(built.items);
        })
        .then(function () {
          setStatus('', false);
          closeModal();
          return bundle.openCartAfterAdd(config);
        })
        .catch(function (err) {
          setStatus(err && err.message ? err.message : config.errorLabel, true);
        })
        .finally(function () {
          setAddButtonsDisabled(false);
        });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest(OPEN_TRIGGER);
      if (!trigger || trigger.hasAttribute('hidden')) return;
      if (trigger.closest(TRIGGER_WRAP + '[hidden]')) return;
      event.preventDefault();
      openModal(trigger);
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        closeModal();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (modal.hasAttribute('hidden')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key === 'Tab' && dialog) {
        var focusable = getFocusableElements(dialog);
        if (!focusable.length) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    planInputs.forEach(function (input) {
      input.addEventListener('change', updateBreakdown);
    });

    addButtons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        handleAddToCart();
      });
    });

    document.addEventListener('monthlees:cart-membership-toggle', syncTriggerVisibility);
    document.addEventListener('monthlees:cart-updated', syncTriggerVisibility);

    modal.dataset.initialized = 'true';
    syncTriggerVisibility();
  }

  function init() {
    var modal = document.querySelector(MODAL);
    if (modal) initModal(modal);
    syncTriggerVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
